<div class="row"  *ngIf="(quizEnvelop && !loading)">
    <div class="col-sm-12">
        <div class="card">
          <h6 class="card-header text-center" [appMath]="title"></h6>
            <div class="card-header">
                <h1  class="text-center">{{quizEnvelop.studentName}}</h1>
                <h2 id="quizInfo" class="text-center">Quiz {{quizEnvelop.server_quiz_envelop_id}} for {{quizEnvelop.subjectName}}:{{quizEnvelop.level_name}}</h2>
                <h3 id="quizDate" class="text-center">Date:{{quizEnvelop.datecreated}}</h3>
            </div>
            <div class="card-body">
                <div  *ngIf="quizEnvelop.questions.length>0" class="table-responsive">
                    <table class="table table-striped table-borderless">
                      <tbody>
                          <tr *ngFor="let question of  quizEnvelop.questions; index as myCount;">
                            <td id="myquestion_{{question.server_question_id}}" *ngIf="!loading">
                              <app-show-question
                              (renderMathRequest)="renderMathPage($event)"
                              [question]="question"
                              [learner] ="learner"
                              [myCount]="myCount"
                              [quizEnvelop]="quizEnvelop"> </app-show-question>
                          </td>
                          </tr>

                      </tbody>
                    </table>
                 </div>
            </div>
            <div class="card-footer">
                <fieldset class="buttons text-center">

                    <a [routerLink]="['/student/show',learner.server_user_id]"
                        class="btn btn-outline-primary margin-50-right">
                        <i class="fa fa-home"></i>Home
                   </a>

                    <a *ngIf="quizEnvelop"
                        [routerLink]="['/student/quiz/do',learner.server_user_id,quizEnvelop.server_quiz_envelop_id,quizEnvelop.questions[0].server_question_id,0]"
                        class="btn btn-outline-primary
                        margin-50-right" >
                        <i class="fa fa-pencil"></i>Answer Quiz
                    </a>
                    <button (click)="downloadPdf(quizEnvelop.server_quiz_envelop_id)"
                        class="btn btn-outline-primary">
                        <i *ngIf="!downloading" class='fa fa-file-pdf-o'></i>
                        <span *ngIf="downloading" class="spinner-border spinner-border-lg me-1 text-info"></span>

                    </button>
                </fieldset>
            </div>
        </div>
</div>
</div>
<app-spinner *ngIf="loading"></app-spinner>
